import itLocale from 'element-ui/lib/locale/lang/it' //引入element语言包
const it = {
  posterPage: {
    title1:'La funzione di abbonamento è pronto!',
    title2:'Abbonamento rinnovato, aggiornamento privilegiato!',
    title3:'Sconto esclusivo, rinnovo più economico',
    title4:"Per ottenere il codice di scambio, puoi consultare il venditore che ha acquistato l'attrezzatura",
    title5:'Funzioni di esperienza prioritarie',
    function1:'Dettagli della funzione:',
    function2:'Rinnovamento dei servizi di base (traduttore simultaneo, assistente per conferenze, assistente intelligente)...',
    function3:'Abbonamento a servizi a valore aggiunto (traduzione offline, traduzione di chiamate audio-video)...',
  },
  RedemptionCodePage: {
    RedemptionCode: 'Codice di rimborso',
    ValueAddedServices: 'servizi a valore aggiunto',
    UpgradedExperience: 'Vantaggi esclusivi a valore aggiunto, esperienza migliorata',
    OfflineTranslation: 'Traduzione offline',
    NoInternet: "Non c'è bisogno di connessione internet, traduzione istantanea, sicuro e affidabile",
    GoToSubscribe: 'Vai a iscriverti',
    AudioAndVideoCall: 'Chiamata audio/video',
    RealTimeCall: 'Accessibilità della traduzione vocale e della comunicazione in tempo reale',
    BaseService: 'Servizi di base',
    AIAssistant: 'Funzioni: interpretazione simultanea, assistente conferenza, assistente AI',
    LanguagesSetting:'Impostazioni della lingua',
    languages1:'Cinese semplificato',
    languages2:'Cinese tradizionale',
    languages3:'Inglese',
    languages4:'Giapponese',
    languages5:'Coreano',
    languages6:'russo',
    languages7:'Spagnolo',
    languages8:'francese',
    languages9:'tedesco',
    languages10:'Portoghese',
    languages11:'Italiano',
    languages12:'Turco',
    languages13:'Vietnamita',
    languages14:'Indonesiano',
    languages15:'Hindi',
    languages16:'arabo',
    languages17:'Thailandese',
    languages18:'Persiano',
  },
  Login: {
    ToLogin: 'login',
    PhoneLogin: 'Login con numero di telefono',
    EmailLogin: 'Accesso via email',
    PhonePlaceholder: 'Inserisci il tuo numero di telefono',
    EmailPlaceholder: 'Enter email',
    Code: 'Codice di verifica',
    and: 'e',
    BeforeText: 'La creazione di un account rappresenta il tuo accordo e la conformità',
    UserAgreement: 'Accordo utente',
    privacy: 'Informativa sulla privacy',
    errorMessage: 'Errore del codice di verifica',
    readTitle: 'Leggere e accettare il seguente accordo',
    readBefore: 'Per garantire la sicurezza delle tue informazioni personali, ti preghiamo di leggere e accettare prima',
    cancel: 'annulla',
    agree: 'Accettare e continuare',
    error1:'Inserisci un indirizzo email valido',
    error2:'Inserisci il numero di cellulare corretto',
    error3:'Inserisci il codice di verifica',
    success:'Login riuscito'
  },
  OffLinePage: {
    title: 'Traduzione offline',
    NoInternet: "Non c'è bisogno di connessione internet, traduzione istantanea, sicuro e affidabile",
    ServiceLife: 'vita utile',
    forever: 'Uso permanente',
    describe: "Istruzioni per l'abbonamento",
    describeItem1: "1. La funzione di traduzione offline è un pagamento una tantum, uso permanente, e l'autorizzazione di utilizzo segue il dispositivo Bluetooth. Se si cambia il dispositivo, è necessario iscriversi nuovamente al codice di riscatto della traduzione offline.",
    describeItem2: "2. L'abbonamento al codice di autorizzazione non è rimborsabile.",
    describeItem3: '3. Supporta 10 lingue: cinese, inglese, tedesco, giapponese, coreano, hindi, tailandese, spagnolo, francese, russo.',
    quantity: 'quantità',
    payType: 'Metodo di pagamento',
    card: 'Carta bancaria',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'subscribe to',
    RMB: '¥',
    confirm:'conferma',
    cardNumber:'Numero della carta',
    periodOfValidity:'periodo di validità',
    safetyCode:'codice di sicurezza',
    name:'nome completo',
    yearAndMonth:'Anno/mese',
    message1:'Il numero non può essere 0.',
    popTip:'Consigli',
    popText1:'Si prega di leggere attentamente e capire',
    popText2:'Contratti di traduzione offline a pagamento',
    popText3:'Ho letto e accetto',
    popText4:'Ho letto e accetto',
  },
  AudioVideoPage: {
    title: 'Chiamata audio/video',
    RealTime: 'Accessibilità della traduzione vocale e della comunicazione in tempo reale',
    describe: "Istruzioni per l'abbonamento",
    describeItem1: "1. La funzione di traduzione audio e video chiamata è quella di ricaricare e acquistare minuti. I minuti contano dal momento in cui la chiamata è collegata, e le autorizzazioni seguono l'account. Se si accede a un altro account, è necessario ricaricare nuovamente.",
    describeItem2: "2. Dopo aver ricaricato l'account, collegare e legare diversi dispositivi può ancora essere utilizzato come al solito.",
    describeItem3: '3. La funzione di traduzione audio e video chiamata non può essere rimborsata dopo la ricarica.',
    payType: 'Metodo di pagamento',
    card: 'Carta bancaria',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'subscribe to',
    RMB: '¥',
    sale: 'sconto',
    confirm:'conferma',
    time1:'Secondi',
    time2:'minuti',
    time3:'ore',
    time4:'Giorno',
    time5:'mese',
    time6:'anno',
  },
  OffLineResult: {
    title1: 'Traduzione offline',
    title2: 'Chiamata audio/video',
    title3: 'Servizi di base',
    success: 'Abbonamento riuscito',
    fail: 'Iscrizione non riuscita',
    stock:'Codice di scambio in stock',
    saveTitle: "Salva il codice di riscatto e vai all'app per riscattarlo",
    code: 'Codice di rimborso',
    tip1: 'Questo codice viene utilizzato solo per riscattare la funzione di traduzione offline',
    tip2: 'Questo codice viene utilizzato solo per riscattare la funzione di traduzione di chiamate audio/video',
    tip3: 'Questo codice viene utilizzato solo per riscattare le funzioni di rinnovo del servizio di base',
    save: 'salva',
    time: "Durata dell'abbonamento:",
    copy: 'copia',
    copySuccess: 'Replicare il successo',
    loading:'Caricamento',
    paySuccess:'Pagamento riuscito'
  },
  RedemptionList: {
    title: 'Il mio codice di riscatto',
    view: 'vista',
    time: "Durata dell'abbonamento:",
  },
  MyRedemption: {
    title: 'Il mio codice di riscatto',
    code: 'Codice di rimborso',
    time: "Durata dell'abbonamento:",
    copy: 'copia',
    tip1: 'Questo codice viene utilizzato solo per riscattare la funzione di traduzione offline',
    tip2: 'Questo codice viene utilizzato solo per riscattare la funzione di traduzione di chiamate audio/video',
    tip3: 'Questo codice viene utilizzato solo per riscattare le funzioni di rinnovo del servizio di base',
    save: 'salva',
    success:"Operazione riuscita"
  },
  basePage:{
    error1:'Non sono state ottenute informazioni sul prodotto',
    message1:'Seleziona un prodotto',
    title:'Servizi di base',
    function:'Funzioni: interpretazione simultanea, assistente conferenza, assistente AI',
    describe: "Istruzioni per l'abbonamento",
    describe1:"1. Dopo il rinnovo dei servizi di base come la traduzione simultanea e l'assistente di conferenza, il periodo di validità segue l'attrezzatura. Se l'attrezzatura viene sostituita, deve essere rinnovata.",
    describe2:'2. I servizi di base non possono essere rimborsati dopo il rinnovo.',
    payType: 'Metodo di pagamento',
    card: 'Carta bancaria',
    wx: 'WeChat',
    GooglePay: 'Google Pay',
    subscribe: 'subscribe to',
    RMB: '¥',
    sale: 'sconto',
    month:'la luna',
    confirm:'conferma',
    month1:'1 mese',
    month2:'Mezzo anno',
    month3:'1 anno'
  },
  ...itLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default it;
